
import '../assets/scss/style.scss';
import { defineComponent, ref } from "@vue/runtime-core";

export default defineComponent({
    name: "BaseApparelComingSoon",
    data() {
        const emailAddress = ref("");
        const isValid = ref(true);
        const validate =function() {
            if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(emailAddress.value)) {
                isValid.value = true;
            } else {
                isValid.value = false;
            }
            return isValid.value;
        };
        const signup = function() {
            if (validate()) {
                alert("Thank you for registering!");
                emailAddress.value = "";
            }
        }
        return {
            emailAddress,
            isValid,
            signup
        }
    }
})
